import { render, staticRenderFns } from "./SoftwareInventory.vue?vue&type=template&id=68f1e39c"
import script from "./SoftwareInventory.vue?vue&type=script&lang=js"
export * from "./SoftwareInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports